import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useIntl } from "react-intl"

function SEO({
  description,
  lang,
  meta,
  title,
  keywords,
  uriPath,
  ogImage,
  baseSlug,
  script,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            domainUrl
            defaultOgImage
          }
        }
      }
    `
  )
  // console.log("seo site", site)
  const metaDescription = description || site.siteMetadata.description
  const metaTitle = title || site.siteMetadata.title
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={[
        {
          rel: "canonical",
          href: `${site.siteMetadata.domainUrl}/${lang}/${baseSlug}`,
        },
        {
          rel: "alternate",
          hreflang: "en",
          href: `${site.siteMetadata.domainUrl}/en/${baseSlug}`,
        },
        {
          rel: "alternate",
          hreflang: "zh-hk",
          href: `${site.siteMetadata.domainUrl}/zh-HK/${baseSlug}`,
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: `${site.siteMetadata.domainUrl}/zh-HK/${baseSlug}`,
        },
        {
          rel: "alternate",
          hreflang: "zh-cn",
          href: `${site.siteMetadata.domainUrl}/zh-CN/${baseSlug}`,
        },
        {
          rel: "preconnect",
          href: "https://hm.baidu.com",
        },
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: `${site.siteMetadata.domainUrl}/${lang}/${baseSlug}`,
        },
        {
          property: `og:image`,
          content: `${site.siteMetadata.domainUrl}${
            ogImage || site.siteMetadata.defaultOgImage
          }`,
        },
      ].concat(meta)}
      script={[].concat(script)}
    ></Helmet>
  )
}

SEO.defaultProps = {
  lang: `zh-HK`,
  meta: [],
  description: ``,
  ogImage: ``,
  script: [],
}
SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  ogImage: PropTypes.string,
}
export default SEO
